<template>
	<modal v-model="isOpen" name="wishlist" class="add-to-wishlist-btn">
		<div slot="label" class="d-flex align-items-center clickable semibold">
			Spara
			<img class="icon" :src="convertToCdnUrl('/img/icons/heart-empty.svg')" alt="heart icon" />
		</div>
		<div v-if="user.id" class="p-5" style="width: 500px; max-width: 100%">
			<h2>Spara i önskelista</h2>
			<dropdown-select
				v-model="selectedWishlistId"
				center
				fullWidth
				class="my-5"
				prefix="Lista:"
				:items="wishlistOptions"
				:formatter="t => t"
			/>
			<div class="form-group" v-if="selectedWishlistId === 0" style="text-align: left">
				<label for="wishlistName">
					Namn
				</label>
				<input
					v-model="newListName"
					class="form-control"
					id="wishlistName"
					:placeholder="wishlistPlaceholderName"
				/>
			</div>
			<text-button
				class="pull-right"
				text="Spara"
				@click="save"
			/>
		</div>
		<member-form
			v-else
			class="add-to-wislisht-member-form"
			:showCloseButton="false"
			value="register"
			openedViaModal="wishlist"
			:specialHeading="registerHeading"
		/>
	</modal>
</template>

<script>
import waja from 'waja';
import alert from 'alert';
import { mapState } from 'vuex';
import format from 'date-fns/format';
import localSessionStorage from 'localSessionStorage';
import { convertToCdnUrl } from 'utils';
import { isDesktop } from 'mediaQuery';

export default {
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {
			newListName: '',
			selectedWishlistId: 0,
			isOpen: false,
			loadStarted: false,
			wishlists: [],
			registerHeading: 'Bli medlem för att spara din önskelista',
		};
	},
	methods: {
		convertToCdnUrl,
		save () {
			if (this.selectedWishlistId === 0) {
				const name = this.newListName || this.wishlistPlaceholderName;
				waja.post('wishlist')
					.data({
						name,
					}).on('success', res => {
						const wishlist = res.data.wishlist;
						this.wishlists.push(wishlist);
						this.selectedWishlistId = wishlist.id;
					}).go();
				return;
			}
			waja.put('wishlist/' + this.selectedWishlistId)
				.data({
					productId: this.product.id,
					touchpoint: isDesktop() ? 'DESKTOP' : 'MOBILE'
				}).on('success', res => {
					localSessionStorage.set('selectedWishlistId', this.selectedWishlistId);
					alert('Produkten har sparats!');
					this.newListName = '';
				}).go();

			this.isOpen = false;
		},
		getPreSelectedId () {
			const savedId = ~~localSessionStorage.get('selectedWishlistId');
			let preSelectedId = 0;
			if (this.wishlists.length) {
				// Check if selected wishlist still exists.
				for (const wishlist of this.wishlists) {
					if (savedId && wishlist.id === savedId) {
						return savedId;
					}
				}
				// Default to last created wishlist.
				preSelectedId = this.wishlists[this.wishlists.length - 1].id;
			}
			return preSelectedId;
		},
	},
	computed: {
		wishlistOptions () {
			const lists = [
				{
					label: 'Skapa ny',
					value: 0,
				},
			];
			for (const list of this.wishlists) {
				lists.push({
					label: list.name,
					value: list.id,
				});
			}
			return lists;
		},
		wishlistPlaceholderName () {
			return 'Önskelista ' + format(new Date(), 'YYYY-MM-DD');
		},
		...mapState({
			user: state => state.user,
		}),
	},
	watch: {
		selectedWishlistId (to, frm) { // Autosparar kundvagn vid val i dropdownmenyn, samt vid skapande av ny lista
			if (! to || to === this.getPreSelectedId()) {
				// Prevent product from being autosaved to wishilist when opening
				// modal for the first time / when selecting the option to create
				// a new list.
				return;
			}
			this.save();
		},
		isOpen (isOpen) {
			if (! isOpen) {
				return;
			}
			if (! this.loadStarted) {
				this.loadStarted = true;
				waja.get('wishlist')
					.on('success', res => {
						this.wishlists = res.data.wishlists;
						this.selectedWishlistId = this.getPreSelectedId();
					}).go();
			} else {
				this.selectedWishlistId = this.getPreSelectedId();
			}
		},
	},
};
</script>
